<template>
  <div class="_d-flex">
    <div class="layout-editor__wrapper">
      <div class="layout-editor__control-panel -left">
        <h3>Change Type</h3>
        <a-button @click="changeShapeType('static')" size="small">Static</a-button>
        <a-button @click="changeShapeType('scenery')" size="small">Scenery</a-button>
        <a-button @click="changeShapeType('interactive')" size="small">Interactive</a-button>

        <a-upload
          ref="upload"
          :multiple="false"
          action
          accept="image/svg+xml"
          @change="onFileChange"
          :showUploadList="false"
        >
          <a-button>Import SVG</a-button>
        </a-upload>
        <a-upload
          ref="uploadImage"
          :multiple="false"
          action
          accept="image/*"
          @change="onImageFileChange"
          :showUploadList="false"
        >
          <a-button>Add Image</a-button>
        </a-upload>

        <a-button @click="drawShape('polygon')" v-if="!isDrawing">Draw Polygon</a-button>
        <a-button type="primary" @click="drawShapeDone()" v-if="isDrawing">Done</a-button>

        <a-button @click="drawShape('polygon', true)">Add Point</a-button>
        <!-- <a-button @click="addShape('rect')">Add Rect</a-button> -->
        <a-button @click="enablePlacing('rect')">Add Rect</a-button>

        <a-button @click="enablePlacing('circle')">Add Circle</a-button>
        <a-button type="primary" @click="save">Save</a-button>
      </div>

      <div class="layout-editor__control-panel -right">
        <div class="_m-b-3">
          <a-button @click="undoredo('undo')">Undo</a-button>
          <a-button @click="undoredo('redo')">Redo</a-button>
        </div>
        <div>
          <div>
            <a-input-number
              :step="0.01"
              v-model="elementRotation"
              @change="onRotationEnter"
              placeholder="Rotation"
            />
          </div>
        </div>

        <div v-if="selectedShapesAmount == 1 && getFirstSelectedElement.shapeType == 'rect'">
          <div>
            <a-input-number
              :step="0.01"
              v-model="elementSize.width"
              @change="onSizeEnter('width', $event)"
              placeholder="Width"
            />
          </div>
          <div>
            <a-input-number
              :step="0.01"
              v-model="elementSize.height"
              @change="onSizeEnter('height', $event)"
              placeholder="Height"
            />
          </div>
        </div>
        <div v-else-if="selectedShapesAmount == 1 && getFirstSelectedElement.shapeType == 'circle'">
          <div>
            <a-input-number
              :step="0.01"
              v-model="elementSize.r"
              @change="onSizeEnter('r', $event)"
              placeholder="Radius"
            />
          </div>
        </div>
      </div>

      <svg
        v-if="layout"
        style="width: inherit; height: inherit;"
        id="layout-editor"
        viewBox="0 0 500 500"
        @mousedown="onMouseDown"
        @mousemove="onMouseMove"
        @mouseup="onMouseUp"
        @keydown.up.down.left.right="onArrowDown"
      >
        <g class="layout-editor__viewport" id="layout-editor-viewport">
          <app-layout-shape
            :ref="`layoutShape_${shape.id}`"
            v-for="(shape, index) in layoutImages"
            :key="`layout-image-${shape.id}`"
            :shapeObj="shape"
            @select="onShapeSelect"
            @resizeHandleDown="onShapeResizeHandleDown"
            @rotateHandleDown="onShapeRotateHandleDown"
            :selectedIds="selectedShapeIds"
            :selectedShapesAmount="selectedShapesAmount"
            :svg="svg"
          ></app-layout-shape>

          <app-layout-shape
            :ref="`layoutShape_${shape.id}`"
            v-for="(shape, index) in layoutShapes"
            :key="`layout-shape-${shape.id}`"
            :shapeObj="shape"
            @select="onShapeSelect"
            @resizeHandleDown="onShapeResizeHandleDown"
            @rotateHandleDown="onShapeRotateHandleDown"
            :selectedIds="selectedShapeIds"
            :selectedShapesAmount="selectedShapesAmount"
            :svg="svg"
            :titleValue="currentLevel.schema.data[shape.id] ? currentLevel.schema.data[shape.id][currentProject.boothSettings.titleField] : '[]'"
          ></app-layout-shape>

          <!-- <polygon v-if="isDrawing && drawShapeData.points" :points="drawPolygonPointsString"></polygon> -->
          <rect
            v-if="isPlacing && placingShape.type == 'rect'"
            x="0"
            y="0"
            :width="placingShape.width"
            :height="placingShape.height"
            class="shape-placeholder"
            :transform="`translate(${placingShape.x} ${placingShape.y})`"
          ></rect>
          <circle
            v-if="isPlacing && placingShape.type == 'circle'"
            :cx="0"
            :cy="0"
            r="50"
            class="shape-placeholder"
            :transform="`translate(${placingShape.x} ${placingShape.y})`"
          ></circle>
        </g>
      </svg>
    </div>

    <app-schema-panel
      v-if="selectedShapesAmount <= 1 && getFirstSelectedElement"
      :currentProject="currentProject"
      :schema="currentLevel.schema"
      @property-changed="onPropertyChanged"
    ></app-schema-panel>
  </div>
</template>

<script>
import svgPanZoom from "svg-pan-zoom";
import hotkeys from "hotkeys-js";
import _ from "lodash";
import Vue from "vue";

import AppSchemaPanel from "@/components/schema/Panel";
import AppLayoutShape from "@/components/layout-editor/LayoutShape";

export default {
  props: {
    currentProject: {
      type: Object
    },
    currentLevel: {
      type: Object
    }
  },
  data() {
    return {
      selectedShapes: {},
      selectedShapeRefs: {},
      layout: {
        name: null,
        data: {}
      },
      schema: {
        data: {}
      },
      panZoomPlan: null,
      svg: null,
      ctm: null,
      isDragging: false,
      isDrawing: false,
      isResizing: false,
      isPlacing: false,
      placingShape: {
        type: null,
        x: 0,
        y: 0,
        width: 50,
        height: 50
      },
      lastClientX: null,
      lastClientY: null,
      shouldEmitChange: false,
      drawShapeData: {
        type: "",
        points: []
      },
      isDrawingFirstClick: false,
      addPointToSelected: false,

      elementSize: {
        height: null,
        width: null,
        r: null
      },
      elementRotation: null,

      layoutDataHistory: [],
      currentLayoutDataHistoryIndex: null,

      isMouseDownOnElement: false
    };
  },
  watch: {
    currentLevel: {
      immediate: true,
      handler(level) {
        this.$log.info("[layout-editor] -> layoutData prop changed");
        this.$set(this, "layout", level.layout);
        this.$set(this, "schema", level.schema);
        this.layoutDataHistory.push(Object.values(level.layout.data));
        this.$nextTick(() => {
          console.log("layoutdatachanged");
          if (this.panZoomPlan) {
            console.log("updatebbox");
            this.updateBBox();
            this.panZoomPlan.resize();
            this.panZoomPlan.fit();
            this.panZoomPlan.center();
            this.panZoomPlan.zoomBy(0.7);
          }
        });
      }
    }

    // "layout.data": {
    //   deep: true,
    //   handler(value) {
    //     this.currentLayoutDataHistoryIndex = this.layoutDataHistory.length - 1;
    //   }
    // }
  },
  methods: {
    onPropertyChanged({ boothId, propId, value }) {
      if (!this.schema.data[boothId]) {
        this.$set(this.schema.data, boothId, {});
      }
      this.$set(this.schema.data[boothId], propId, value);
    },

    undoredo(type) {
      this.$log.info(`history action -> ${type}`);

      if (_.isNil(this.currentLayoutDataHistoryIndex))
        this.currentLayoutDataHistoryIndex = this.layoutDataHistory.length - 1;

      if (type == "undo") {
        if (this.currentLayoutDataHistoryIndex == 0) return false;
        this.currentLayoutDataHistoryIndex -= 1;
      } else {
        if (
          this.currentLayoutDataHistoryIndex ==
          this.layoutDataHistory.length - 1
        )
          return false;
        this.currentLayoutDataHistoryIndex += 1;
      }

      if (!this.layoutDataHistory[this.currentLayoutDataHistoryIndex])
        return false;

      this.$log.info("undoredo");

      this.layoutDataHistory[this.currentLayoutDataHistoryIndex].forEach(e => {
        this.$log.info("current attr", this.layout.data[e.id]);
        this.$log.info("new attr", e.attributes);
        this.$set(
          this.layout.data[e.id],
          "attributes",
          _.cloneDeep(e.attributes)
        );
      });
    },

    onRotationEnter(value) {
      for (let shapeRef in this.selectedShapeRefs) {
        this.selectedShapeRefs[shapeRef].setRotation(value);
      }
    },

    onSizeEnter(type, value) {
      const selectedElement = this.getFirstSelectedElement;

      this.selectedShapeRefs[selectedElement.id].setSize(type, value * 10);
    },

    drawShape(type, addToSelected = false) {
      this.isDrawing = true;
      this.togglePan(false);
      this.drawShapeData.type = type;
      this.isDrawingFirstClick = addToSelected ? false : true;
      this.addPointToSelected = addToSelected;
    },
    drawShapeDone() {
      const firstId = Object.keys(this.selectedShapes)[0];
      this.$set(
        this.layout.data,
        firstId,
        _.cloneDeep(this.selectedShapeRefs[firstId].shape)
      );
      this.isDrawing = false;
      this.drawShapeData.type = "";
      this.isDrawingFirstClick = false;
      this.togglePan(true);
    },
    save() {
      this.$log.info("[layout-editor] -> emit save (layout)");
      this.$emit("save", {
        layout: this.layout,
        schema: this.schema
      });
    },
    enablePlacing(type) {
      this.placingShape.type = type;

      var cursorPoint = this.getCursorPoint(event);
      this.placingShape.x = cursorPoint.x - 25;
      this.placingShape.y = cursorPoint.y - 25;

      this.isPlacing = true;
    },
    onShapeResizeHandleDown({ handle, id }) {
      this.isResizing = true;
      this.togglePan(false);
    },
    onShapeRotateHandleDown({ id }) {
      this.isRotating = true;
      this.togglePan(false);
    },
    onMouseDown(event) {
      if (event.target) {
        if (event.target.classList.contains("shape__element")) {
          // this.togglePan(false);
          // this.isDragging = true;
          this.isMouseDownOnElement = true;
          return true;
        }
      }

      return false;
    },
    getSvgCTM: function() {
      var ctm =
        this.ctm || document.getElementById("layout-editor").getScreenCTM();
      return ctm;
    },
    getCursorPoint: function(event) {
      var svgMap = document.getElementById("layout-editor");

      var point = svgMap.createSVGPoint();

      point.x = event.clientX;
      point.y = event.clientY;

      var newCtm = this.ctm || svgMap.getScreenCTM();

      return point.matrixTransform(newCtm.inverse());
    },
    getCursorPointEditor: function(event) {
      const svgP = this.svg.createSVGPoint();
      svgP.x = event.clientX;
      svgP.y = event.clientY;

      const rotatedPoint = svgP.matrixTransform(
        document
          .getElementById("layout-editor-viewport")
          .getScreenCTM()
          .inverse()
      );

      return rotatedPoint;
    },
    onMouseMove(event) {
      event.preventDefault();

      if (this.isMouseDownOnElement) {
        this.togglePan(false);
        this.isDragging = true;
      }

      let cursorPoint = this.getCursorPoint(event);

      if (this.isPlacing) {
        cursorPoint = this.getCursorPointEditor(event);

        if (this.placingShape.type == "rect") {
          this.placingShape.x = cursorPoint.x - this.placingShape.width / 2;
          this.placingShape.y = cursorPoint.y - this.placingShape.height / 2;
        } else {
          this.placingShape.x = cursorPoint.x;
          this.placingShape.y = cursorPoint.y;
        }
      } else if (this.isDragging || this.isResizing || this.isRotating) {
        cursorPoint = this.getCursorPoint(event);

        let moveX = 0;
        let moveY = 0;
        if (this.lastClientX) {
          moveX = cursorPoint.x - this.lastClientX;
        }
        if (this.lastClientY) {
          moveY = cursorPoint.y - this.lastClientY;
        }

        if (this.isDragging) {
          _.forOwn(this.selectedShapeRefs, obj => {
            obj.move(moveX, moveY);
          });
        } else if (this.isResizing) {
          _.forOwn(this.selectedShapeRefs, obj => {
            obj.resize(moveX, moveY, event);
          });
        } else if (this.isRotating) {
          _.forOwn(this.selectedShapeRefs, obj => {
            obj.rotate(moveX, moveY);
          });
        }
      }
      this.lastClientX = cursorPoint.x;
      this.lastClientY = cursorPoint.y;
    },
    onMouseUp(event) {
      this.isMouseDownOnElement = false;
      if (this.isPlacing) {
        const cursorPoint = this.getCursorPointEditor(event);

        if (this.placingShape.type == "rect") {
          this.addShape(
            this.placingShape.type,
            cursorPoint.x - this.placingShape.width / 2,
            cursorPoint.y - this.placingShape.height / 2
          );
        } else {
          this.addShape(this.placingShape.type, cursorPoint.x, cursorPoint.y);
        }
      }
      if (this.isDrawing) {
        const cursorPoint = this.getCursorPointEditor(event);

        if (this.isDrawingFirstClick) {
          this.isDrawingFirstClick = false;
          this.addShape(this.drawShapeData.type, cursorPoint.x, cursorPoint.y);
        } else {
          _.forOwn(this.selectedShapeRefs, obj => {
            obj.addPoint(cursorPoint, event, this.addPointToSelected);
          });
          if (this.addPointToSelected) {
            this.isDrawing = false;
          }
        }
      } else if (this.isDragging || this.isResizing) {
        this.updateChangedElements();
        this.isDragging = false;
        this.isResizing = false;
        this.togglePan(true);
      } else if (this.panZoomPlan) {
        this.isDragging = false;
        this.isResizing = false;
        this.isRotating = false;
        this.togglePan(true);
        this.lastClientX = null;
        this.lastClientY = null;
      }
    },
    togglePan(enable) {
      this.$log.info("[layout-editor][pan-zoom] -> toogle pan", enable);

      if (enable) this.panZoomPlan.enablePan();
      else if (!enable) this.panZoomPlan.disablePan();
    },
    initPlanSVG() {
      if (this.panZoomPlan) return false;

      this.$log.info("[layout-editor] -> init panZoom");
      const vm = this;
      var options = {
        viewportSelector: ".layout-editor__viewport",
        zoomEnabled: true,
        controlIconsEnabled: false,
        zoomScaleSensitivity: 0.5,
        minZoom: 0.25,
        maxZoom: 50,
        onUpdatedCTM: newCtm => {
          vm.ctm = newCtm;
        }
      };

      this.svg = document.getElementById("layout-editor");

      if (!this.svg) {
        this.$log.error("[layout-editor] -> #layout-editor not found");
      }
      this.$log.info("[layout-editor] -> viewport found");

      this.panZoomPlan = svgPanZoom("#layout-editor", options);
      this.updateBBox();
      this.panZoomPlan.resize();
      this.panZoomPlan.fit();
      this.panZoomPlan.center();
      this.panZoomPlan.zoomBy(0.7);
    },

    updateBBox() {
      if (!_.isEmpty(this.layout.data)) {
        this.panZoomPlan.updateBBox();
      }
    },

    updateChangedElements() {
      this.$log.info("[layout-editor] -> saving shape-state");

      if (
        this.currentLayoutDataHistoryIndex !=
        this.layoutDataHistory.length - 1
      ) {
        this.layoutDataHistory.splice(this.currentLayoutDataHistoryIndex + 1);
      }

      let state = [];
      _.forOwn(this.selectedShapeRefs, obj => {
        this.$set(this.layout.data, obj.shape.id, _.cloneDeep(obj.shape));
        state.push(_.cloneDeep(obj.shape));
      });
      this.layoutDataHistory.push(state);
      this.currentLayoutDataHistoryIndex = this.layoutDataHistory.length - 1;
    },

    deleteShape() {
      // console.log("deleting shapes", this.selectedShapes);
      // return false;
      _.forOwn(this.selectedShapes, (value, key) => {
        // console.log("deleting", key);
        this.$delete(this.layout.data, key);
        // console.log(this.layout.data);
      });
    },
    onShapeSelect({ shape, shiftKey }) {
      if (this.isDragging) return false;

      if (this.selectedShapes[shape.id] && shiftKey) {
        this.$delete(this.selectedShapes, shape.id);
        this.$delete(this.selectedShapeRefs, shape.id);
      } else {
        this.selectShape(shape.id, shiftKey);
      }

      this.$log.info(
        "[layout-editor] -> selection changed",
        this.selectedShapes
      );
    },
    selectShape: function(id, keepSelection = false) {
      if (!keepSelection) {
        this.clearSelection();
      } else {
        this.$store.commit("SELECT_BOOTH", null);
      }

      this.$store.commit("SELECT_BOOTH", id);
      this.$set(this.selectedShapes, id, this.layout.data[id]);
      this.$set(this.selectedShapeRefs, id, this.$refs[`layoutShape_${id}`][0]);

      if (this.selectedShapesAmount == 1) {
        if (this.getFirstSelectedElement.shapeType == "rect") {
          this.elementSize.height = (
            this.selectedShapes[id].attributes.height / 10
          ).toFixed(2);
          this.elementSize.width = (
            this.selectedShapes[id].attributes.width / 10
          ).toFixed(2);

          this.elementRotation = this.selectedShapes[
            id
          ].attributes.transform.rotate.deg;
        } else if (this.getFirstSelectedElement.shapeType == "circle") {
          this.elementSize.r = (
            (this.selectedShapes[id].attributes.r / 10) *
            2
          ).toFixed(2);
        }
      }
    },
    changeShapeType(type) {
      for (let key in this.selectedShapes) {
        this.$log.info("change shape type", type, key);
        this.$set(this.layout.data[key], "layoutType", type);
      }
    },
    onArrowDown(event) {
      event.preventDefault();

      const moveAmount = event.shiftKey ? 20 : event.ctrlKey ? 1 : 5;

      let moveX = 0;
      let moveY = 0;

      if (event.key == "ArrowUp") moveY = moveAmount * -1;
      else if (event.key == "ArrowDown") moveY = moveAmount;
      else if (event.key == "ArrowRight") moveX = moveAmount;
      else if (event.key == "ArrowLeft") moveX = moveAmount * -1;

      _.forOwn(this.selectedShapeRefs, obj => {
        obj.move(moveX, moveY);
      });
      this.$nextTick(() => {
        this.updateChangedElements();
      });
    },
    addShape(type, translateX = 0, translateY = 0) {
      let shape = {
        shapeType: type,
        layoutType: "interactive",
        id: this.randomString(),
        attributes: {
          transform: {
            translate: {
              x: translateX,
              y: translateY
            },
            rotate: {
              deg: 0,
              pointX: 0,
              pointY: 0
            }
          }
        }
      };

      if (type == "rect") {
        shape.attributes = {
          ...shape.attributes,
          height: 50,
          width: 50,
          x: 0,
          y: 0
        };
      } else if (type == "circle") {
        shape.attributes = {
          ...shape.attributes,
          r: 50,
          cx: 25,
          cy: 25
        };
      } else if (type == "polygon") {
        shape.attributes = {
          ...shape.attributes,
          points: [
            {
              x: 0,
              y: 0
            }
          ]
        };
      }

      this.isPlacing = false;

      this.$set(this.layout.data, shape.id, shape);
      this.$set(this.schema.data, shape.id, {});
      this.$nextTick(() => {
        if (!this.panZoomPlan) {
          this.initPlanSVG();
        }
        this.panZoomPlan.updateBBox();
        this.selectShape(shape.id, false);
      });
    },
    onFileChange({ file, fileList }) {
      if (!file) return false;

      var reader = new FileReader();
      reader.readAsText(file.originFileObj, "UTF-8");
      reader.onload = evt => {
        this.$log.info("[layout-editor] -> sending svg-data to api");
        this.axios
          .post("/admin/layout/parse", {
            rawLayout: evt.target.result
          })
          .then(response => {
            this.$log.info(
              "[layout-editor] -> svg-data parsed",
              response.data.layoutData
            );

            this.layout.data = Object.assign({}, response.data.layoutData);
            this.$nextTick(() => {
              this.initPlanSVG();
            });
          });
      };
    },
    onImageFileChange({ file, fileList }) {
      if (!file) return false;

      let formData = new FormData();
      formData.append("image", file.originFileObj);

      this.axios
        .post("/admin/layout/uploadImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.$refs.uploadImage.clearFiles();
          this.$log.info("[layout-editor] -> image uploaded");
          const imageResp = response.data.image;

          const image = {
            id: imageResp.id,
            shapeType: "image",
            attributes: {
              ext: imageResp.ext,
              mimeType: imageResp.mimeType,
              height: imageResp.height,
              width: imageResp.width,
              x: 0,
              y: 0,
              transform: {
                translate: {
                  x: 0,
                  y: 0
                },
                rotate: {
                  deg: 0
                }
              }
            }
          };

          this.$set(this.layout.data, image.id, image);
          this.$nextTick(() => {
            this.initPlanSVG();
          });
        });
    },

    clearSelection() {
      this.$store.commit("SELECT_BOOTH", null);
      // this.selectedShapes = {};
      // this.selectedShapeRefs = {};
      this.$set(this, "selectedShapes", {});
      this.$set(this, "selectedShapeRefs", {});
    }
  },
  computed: {
    selectedShapesAmount() {
      return this.selectedShapes && Object.keys(this.selectedShapes).length;
    },
    selectedShapeIds() {
      return _.map(this.selectedShapes, "id");
    },
    layoutShapes() {
      return (
        this.layout &&
        this.layout.data &&
        Object.values(this.layout.data).filter(s => s.shapeType != "image")
      );
    },
    layoutImages() {
      return (
        this.layout &&
        this.layout.data &&
        Object.values(this.layout.data).filter(s => s.shapeType == "image")
      );
    },

    getFirstSelectedElement() {
      return (
        this.selectedShapes &&
        this.selectedShapes[Object.keys(this.selectedShapes)[0]]
      );
    }
  },
  mounted() {
    this.initPlanSVG();

    hotkeys("del", (event, handler) => {
      if (!_.isEmpty(this.selectedShapes)) {
        this.deleteShape();
      }
      return false;
    });
    hotkeys("esc", (event, handler) => {
      if (!_.isEmpty(this.selectedShapes)) {
        this.clearSelection();
      }
      this.isPlacing = false;
    });
    hotkeys("ctrl+a", (event, handler) => {
      event.preventDefault();
      event.stopPropagation();
      this.$log.info("[layout-editor] -> select all elements");
      _.forOwn(this.layout.data, (value, key) => {
        this.selectShape(value.id, true);
      });
      this.isPlacing = false;
    });
    hotkeys("ctrl+d", (event, handler) => {
      event.preventDefault();

      this.$log.info("copy elements", this.selectedShapes);

      if (!_.isEmpty(this.selectedShapes)) {
        let ids = [];
        _.forOwn(this.selectedShapes, obj => {
          let newObj = _.cloneDeep(this.layout.data[obj.id]);
          newObj.id = this.randomString();
          this.$set(this.layout.data, newObj.id, newObj);
          ids.push(newObj.id);
        });
        this.clearSelection();
        this.$nextTick(() => {
          ids.forEach(id => {
            this.selectShape(id, true);
          });
        });
      }
    });
  },
  components: {
    AppLayoutShape,
    AppSchemaPanel
  }
};
</script>


<style lang="scss" scoped>
.layout-editor {
  &__wrapper {
    height: 60vh;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 0 0 1px #dcdfe6;
    cursor: move;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
  }
  &__viewport {
  }
  &__control-panel {
    position: absolute;
    top: 30px;
    background: transparent;
    display: flex;
    flex-direction: column;
    width: 200px;

    &.-left {
      left: 30px;
    }
    &.-right {
      right: 30px;
    }

    .ant-btn {
      margin: 0 0 10px 0 !important;
    }
  }
}

.shape-placeholder {
  fill: #bbb;
}
</style>